import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "market-mismatch-overlay" }
const _hoisted_2 = { class: "market-mismatch-overlay__message" }



import { modalService } from '@exchange/libs/modals/src';
import SubaccountSelectModal from '@exchange/libs/trading-accounts/ui/src/lib/components/modals/SubaccountSelectModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MarketMismatchOverlay',
  props: {
  isFuturesMarket: { type: Boolean, required: true },
},
  setup(__props) {

const props = __props;

const selectSubaccount = () => {
  const modalKey = modalService.show(
    SubaccountSelectModal,
    {
      isFuturesMarket: props.isFuturesMarket,
    },
    {
      selectSubaccount: () => {
        modalService.hide(modalKey);
      },
      cancelModal: () => {
        modalService.hide(modalKey);
      },
    },
    { canClose: true, centered: true, variant: 'dark' },
  );
};

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.isFuturesMarket ? _ctx.$t('ui.marketMismatch.FUTURES.text') : _ctx.$t('ui.marketMismatch.SPOT.text')), 1),
    _createVNode(_component_x_button, {
      class: "market-mismatch-overlay__button",
      variant: "primary",
      text: _ctx.$t('ui.marketMismatch.action'),
      onClick: selectSubaccount
    }, null, 8, ["text"])
  ]))
}
}

})